document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return

  const { gsap } = window

  const section = document.querySelector('[data-home-about-section]')
  if (!section) return

  const track = section.querySelector('[data-products-track]')
  const bars = track ? Array.from(section.querySelectorAll('[data-indicator-bar]')) : []

  // Mobile carousel
  if (track) {
    const getStep = () => {
      const slide = track.querySelector(':scope > [data-about-slide]')
      if (!slide) return track.clientWidth
      const styles = getComputedStyle(track)
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0
      return slide.offsetWidth + gap
    }

    if (bars.length) {
      const updateIndicator = () => {
        const step = getStep()
        const index = step ? Math.round(track.scrollLeft / step) : 0
        bars.forEach((bar, i) => {
          bar.classList.toggle('bg-black-200', i === index)
          bar.classList.toggle('bg-black-12', i !== index)
        })
      }

      let ticking = false
      track.addEventListener('scroll', () => {
        if (ticking) return
        ticking = true
        requestAnimationFrame(() => {
          updateIndicator()
          ticking = false
        })
      })
    }
  }

  const headingLines = [...section.querySelectorAll('[data-about-line]')].filter((el) => el.offsetParent)
  const imageWrap = section.querySelector('[data-about-image-wrap]')
  const bodyBlock = section.querySelector('[data-about-body]')
  const cta = [...section.querySelectorAll('[data-about-cta]')].find((el) => el.offsetParent)
  const cardsBlock = section.querySelector('[data-about-cards]')
  const productsIndicator = section.querySelector('[data-products-indicator]')

  const reveal = () => {
    gsap.to(headingLines, {
      yPercent: 0,
      opacity: 1,
      duration: 0.9,
      ease: 'power3.out',
      stagger: 0.12,
    })

    if (imageWrap) {
      gsap.to(imageWrap, { y: 0, autoAlpha: 1, duration: 1.3, ease: 'power3.out', delay: 0.15 })
    }

    if (bodyBlock) {
      gsap.to(bodyBlock, { y: 0, autoAlpha: 1, duration: 1.3, ease: 'power3.out', delay: 0.15 })
    }

    if (cardsBlock) {
      gsap.to(cardsBlock, { y: 0, autoAlpha: 1, duration: 1.3, ease: 'power3.out', delay: 0.15 })
    }

    if (productsIndicator) {
      gsap.to(productsIndicator, { y: 0, autoAlpha: 1, duration: 1.3, ease: 'power3.out', delay: 0.15 })
    }

    if (cta) {
      gsap.to(cta, { y: 0, autoAlpha: 1, duration: 1, ease: 'power2.out', delay: 0.4 })
    }
  }

  const buildEntrance = () => {
    if (headingLines.length) gsap.set(headingLines, { yPercent: 120, opacity: 0 })
    if (imageWrap) gsap.set(imageWrap, { y: 40, autoAlpha: 0 })
    if (bodyBlock) gsap.set(bodyBlock, { y: 40, autoAlpha: 0 })
    if (cardsBlock) gsap.set(cardsBlock, { y: 40, autoAlpha: 0 })
    if (productsIndicator) gsap.set(productsIndicator, { y: 40, autoAlpha: 0 })
    if (cta) gsap.set(cta, { y: 20, autoAlpha: 0 })
  }

  buildEntrance()

  if (window.ScrollTrigger) {
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top 60%',
      onEnter: reveal,
    })
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top bottom',
      onLeaveBack: buildEntrance,
    })

    section.querySelectorAll('[data-about-parallax]').forEach((img) => {
      const wrap = img.closest('[data-about-image-wrap], .overflow-hidden')
      gsap.set(img, { scale: 1.25 })
      gsap.fromTo(img,
        { yPercent: 8 },
        {
          yPercent: -8,
          ease: 'none',
          scrollTrigger: {
            trigger: wrap || img.parentElement,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        },
      )
    })
  } else {
    reveal()
  }
})
